import { render, staticRenderFns } from "./TopicName.vue?vue&type=template&id=e12cf54e&scoped=true&"
import script from "./TopicName.vue?vue&type=script&lang=js&"
export * from "./TopicName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12cf54e",
  null
  
)

export default component.exports